import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Nationality, NationalityService } from '@lx/shared/data-access/destination';
import { DropdownModule } from 'primeng/dropdown';
import { SelectorField } from '@lx/quote-tool/lite/shared/ui/directives';
import { getCustomFormComponentControlValueAccessorProvider } from '@lx/quote-tool/lite/shared/utils';
import { DropdownSidePanelFieldComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-nationality-selector',
  imports: [DropdownModule, FormsModule, DropdownSidePanelFieldComponent],
  templateUrl: './nationality-selector.component.html',
  styleUrls: ['./nationality-selector.component.scss'],
  providers: [getCustomFormComponentControlValueAccessorProvider(NationalitySelectorComponent)],
})
export class NationalitySelectorComponent extends SelectorField<string> implements OnInit {
  @Input() title: string;
  nationalities: Nationality[] = [];

  private readonly nationalityService = inject(NationalityService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.nationalityService
      .getAll()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((nationalities: Nationality[]) => {
        this.nationalities = nationalities;
      });
  }
}
